package at.theatervogelweide.admin.contract.connections

import kotlinx.datetime.LocalDateTime
import kotlinx.serialization.Serializable

// All timestamps are in UTC, as stored in the database.

/** An MCP client an admin allowed to work with the admin app (#34), e.g. Claude. */
@Serializable
data class McpConnection(
    val id: Long,
    /** As the client names itself in its metadata document. */
    val clientName: String,
    /** The host of the client's metadata document, which identifies it, e.g. `claude.ai`. */
    val clientHost: String,
    /** Who allowed it. */
    val adminName: String,
    /** Allowed to create and edit, not only to read. */
    val canWrite: Boolean,
    val connectedAt: LocalDateTime,
    val lastUsedAt: LocalDateTime,
    /** When it ends unless the client renews its tokens before. */
    val expiresAt: LocalDateTime,
    /** All changes made through it. */
    val changeCount: Int = 0,
    /** The latest of them, newest first. */
    val recentChanges: List<McpChange> = emptyList(),
)

/** A change an MCP client made, as marked in `mcp_change`. */
@Serializable
data class McpChange(
    /** The MCP tool, e.g. `update_news`. */
    val tool: String,
    val recordType: McpRecordKind,
    val recordId: String?,
    val changedAt: LocalDateTime,
)

/** What was changed; [label] is how the web app names it. */
@Serializable
enum class McpRecordKind(val label: String) {
    NEWS_ITEM("Neuigkeit"),
    ACT("Stück"),
    PERSON("Person"),
    BOARD_MEMBER("Vorstandsmitglied"),
    SPONSOR("Sponsor"),
    CLUB("Vereinstexte"),
    IMPRINT("Impressum"),
    IMAGE("Bild"),
    OTHER("Eintrag"),
    ;

    companion object {
        /** From `mcp_change.record_type`, e.g. `news_item`. */
        fun of(key: String): McpRecordKind = entries.firstOrNull { it.name.lowercase() == key } ?: OTHER
    }
}
